import { render, staticRenderFns } from "./AddMemo.vue?vue&type=template&id=2c31e418&scoped=true&"
import script from "./AddMemo.vue?vue&type=script&lang=js&"
export * from "./AddMemo.vue?vue&type=script&lang=js&"
import style0 from "./AddMemo.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./AddMemo.vue?vue&type=style&index=1&id=2c31e418&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31e418",
  null
  
)

export default component.exports